import axios from 'axios'
import AuthService from '../services/auth'

const _ = require('lodash')

const apiUrl = process.env.VUE_APP_API_URL
const apiKey = process.env.VUE_APP_API_KEY

var h = {}

if (!_.isNil(apiKey)) {
    h = {
        "Content-Type": "application/json",
        "x-api-key": `${apiKey}`
    }
} else {
    h = {
        "Content-Type": "application/json"
    }
}

const apiCall = axios.create({
    baseURL: apiUrl,
    headers: h
})

export default apiCall

// Handle JWT Token
apiCall.interceptors.request.use(config => {
    const tokenJWT = localStorage.getItem('token')

    if (tokenJWT) {
        config.headers['Authorization'] = 'Bearer ' + tokenJWT;
    }

    return config
});

// Token Refresh
apiCall.interceptors.response.use((response) => {
    return response;
}, async (error) => {
    if (error.response.status === 401) {
        const response = await AuthService.refreshToken(localStorage.getItem('refresh-token'));

        if (response.headers["x-token-refresh"]) {
            localStorage.setItem('token', response.headers["x-token-id"])
            localStorage.setItem('refresh-token', response.headers["x-token-refresh"])

            location.reload();
        }
    } else {
        return Promise.reject(error);
    }
})



// WEBPACK FOOTER //
// ./src/repository/index.js